function getCookies() {
    var c = document.cookie, v = 0, cookies = {};
    if (document.cookie.match(/^\s*\$Version=(?:"1"|1);\s*(.*)/)) {
        c = RegExp.$1;
        v = 1;
    }
    if (v === 0) {
        c.split(/[,;]/).map(function (cookie) {
            var parts = cookie.split(/=/, 2),
                name = decodeURIComponent(parts[0].trimLeft()),
                value = parts.length > 1 ? decodeURIComponent(parts[1].trimRight()) : null;
            cookies[name] = value;
        });
    } else {
        c.match(/(?:^|\s+)([!#$%&'*+\-.0-9A-Z^`a-z|~]+)=([!#$%&'*+\-.0-9A-Z^`a-z|~]*|"(?:[\x20-\x7E\x80\xFF]|\\[\x00-\x7F])*")(?=\s*[,;]|$)/g).map(function ($0, $1) {
            var name = $0,
                value = $1.charAt(0) === '"'
                    ? $1.substr(1, -1).replace(/\\(.)/g, "$1")
                    : $1;
            cookies[name] = value;
        });
    }
    return cookies;
}

function getCookie(name) {
    return getCookies()[name];
}

// Set a Cookie
function setCookie(name, value, expiryInMinutes) {
    let date = new Date();
    date.setTime(date.getTime() + (expiryInMinutes * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + "; " + expires + ";SameSite=Lax;";
}

function deleteCookie(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC;SameSite=Lax;";
}

// Expose the cookie helpers as globals. Under the old Sprockets manifest these
// top-level functions were global (files were concatenated, not wrapped), so views
// (e.g. profile/lessons/will_code.html.erb) call getCookie/setCookie from inline
// scripts. esbuild bundles this file in an IIFE and, because nothing references
// these functions through the module graph, tree-shakes the whole file away —
// leaving those callers with undefined globals. Re-expose on window to restore it.
window.getCookies = getCookies;
window.getCookie = getCookie;
window.setCookie = setCookie;
window.deleteCookie = deleteCookie;